(function () {
  function viewportMatches(value) {
    if (!value) return true;
    const tokens = value.split(',').map((t) => t.trim()).filter(Boolean);
    if (tokens.length === 0) return true;
    const isDesktop = window.matchMedia('(min-width: 750px)').matches;
    return tokens.includes(isDesktop ? 'desktop' : 'mobile');
  }

  function closeOpenDetails(except) {
    document
      .querySelectorAll('details[data-auto-close-details][open]')
      .forEach((details) => {
        if (details === except) return;
        if (!viewportMatches(details.dataset.autoCloseDetails)) return;
        details.removeAttribute('open');
        const summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      });
  }

  document.addEventListener('click', function (event) {
    const target = event.target;
    const insideDetails = target.closest && target.closest('details[data-auto-close-details]');
    closeOpenDetails(insideDetails || null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeOpenDetails(null);
  });
})();
